import { ENDPOINTS, requestType } from "../constants/Variables";
import Api from "./index";

const createAttributeValue = (_, params) => {
    return Api(ENDPOINTS.ATTRIBUTE_VALUE.CREATE, params, requestType.POST);
};
const updateAttributeValue = (id, params) => {
    return Api(ENDPOINTS.ATTRIBUTE_VALUE.UPDATE.replace(":id", id), params, requestType.PUT);
};
const getAllAttributeValuesByAttributeId = (id, params) => {

    const url = ENDPOINTS.ATTRIBUTE_VALUE.GET_ALL_BY_ATTRIBUTE_ID.replace(":attributeId", id);

    const queryParams = new URLSearchParams();

    if (params?.search) queryParams.append("search", params.search);

    const finalUrl = queryParams.toString() ?
        `${url}?${queryParams.toString()}`
        : url;

    return Api(finalUrl, null, requestType.GET);
};

const getAttributeValueById = (id) => {
    return Api(ENDPOINTS.ATTRIBUTE_VALUE.SINGLE.replace(":id", id), null, requestType.GET);
};

const deleteAttributeValue = (id) => {
    return Api(ENDPOINTS.ATTRIBUTE_VALUE.DELETE.replace(":id", id), null, requestType.DELETE);
};



export {
    createAttributeValue,
    updateAttributeValue,
    getAllAttributeValuesByAttributeId,
    getAttributeValueById,
    deleteAttributeValue,
};

